module.exports = __webpack_public_path__ + "static/media/1.56ba5d4c.jpeg";